import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {catchError, map, switchMap, takeUntil, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import {LoaderService} from '@app/services/loader.service';
import {
  Report, ReportSuccess, ReportError, ReportPassword, ReportPasswordSuccess, ReportPasswordError,
  ReportAdvocatesExport,
  ReportAdvocatesExportSuccess,
  ReportAdvocatesExportError,
  ResetReportState
} from '@app/stores/report/report.actions';
import {IReportState} from '@app/stores/report/report.state';
import {ImpressionService} from '@app/services/impression.service';
import {ReportAccessTokenService} from '@app/services/report-access-token.service';

@Injectable()
export class ReportEffects {
  private _actions$ = inject(Actions);
  private _store = inject<Store<IReportState>>(Store);
  private impressionService = inject(ImpressionService);
  private loaderService = inject(LoaderService);
  private reportAccessTokenService = inject(ReportAccessTokenService);


  report$ = createEffect(() => this._actions$.pipe(
    ofType(Report),
    switchMap((action) => {
      this.loaderService.show();
      return this.impressionService.report(action.projectId, action.params).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return ReportSuccess({report: resp.data});
          }
          this.loaderService.hide(true);
          return ReportError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(ReportError({error: this.loaderService.getErrorMessage(error)}));
        }),
        takeUntil(this._actions$.pipe(ofType(ResetReportState), tap(() => this.loaderService.hide())))
      );
    })
  ));

  clearReportAccess$ = createEffect(() => this._actions$.pipe(
    ofType(ResetReportState),
    tap(() => this.reportAccessTokenService.clear())
  ), {dispatch: false});

  exportAdvocatesReport$ = createEffect(() => this._actions$.pipe(
    ofType(ReportAdvocatesExport),
    switchMap((action) =>
      // this.loaderService.show();
      this.impressionService.exportAdvocatesReport(action.projectId, action.params).pipe(
        map((resp: any) => {
          if (resp.success) {
            // this.loaderService.hide();
            return ReportAdvocatesExportSuccess({projectsReportAdvocatesExport: resp.data});
          }
          // this.loaderService.hide(true);
          return ReportAdvocatesExportError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error =>
          // this.loaderService.hide(true);
          of(ReportAdvocatesExportError({error: this.loaderService.getErrorMessage(error)}))
        )
      )
    )
  ));

  reportPassword$ = createEffect(() => this._actions$.pipe(
    ofType(ReportPassword),
    switchMap((action) => {
      this.loaderService.show();
      return this.impressionService.reportPassword(action.projectId, action.password).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            this.reportAccessTokenService.set(resp.data);
            return ReportPasswordSuccess({reportPassword: resp.data});
          }
          this.loaderService.hide(true);
          return ReportPasswordError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          this.reportAccessTokenService.clear();
          return of(ReportPasswordError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));
}
